export const countries = [
  { code: 'AD', label: 'Andorra', phone: '376' },
  { code: 'AE', label: 'Emiratos Árabes Unidos', phone: '971' },
  { code: 'AF', label: 'Afganistán', phone: '93' },
  { code: 'AG', label: 'Antigua y Barbuda', phone: '1-268' },
  { code: 'AI', label: 'Anguila', phone: '1-264' },
  { code: 'AL', label: 'Albania', phone: '355' },
  { code: 'AM', label: 'Armenia', phone: '374' },
  { code: 'AO', label: 'Angola', phone: '244' },
  { code: 'AR', label: 'Argentina', phone: '54' },
  { code: 'AT', label: 'Austria', phone: '43' },
  { code: 'AU', label: 'Australia', phone: '61' },
  { code: 'AZ', label: 'Azerbaiyán', phone: '994' },
  { code: 'BA', label: 'Bosnia y Herzegovina', phone: '387' },
  { code: 'BB', label: 'Barbados', phone: '1-246' },
  { code: 'BD', label: 'Bangladesh', phone: '880' },
  { code: 'BE', label: 'Bélgica', phone: '32' },
  { code: 'BF', label: 'Burkina Faso', phone: '226' },
  { code: 'BG', label: 'Bulgaria', phone: '359' },
  { code: 'BH', label: 'Bahrein', phone: '973' },
  { code: 'BI', label: 'Burundi', phone: '257' },
  { code: 'BJ', label: 'Benin', phone: '229' },
  { code: 'BN', label: 'Brunei', phone: '673' },
  { code: 'BO', label: 'Bolivia', phone: '591' },
  { code: 'BR', label: 'Brasil', phone: '55' },
  { code: 'BS', label: 'Bahamas', phone: '1-242' },
  { code: 'BT', label: 'Bután', phone: '975' },
  { code: 'BW', label: 'Botswana', phone: '267' },
  { code: 'BY', label: 'Bielorrusia', phone: '375' },
  { code: 'BZ', label: 'Belice', phone: '501' },
  { code: 'CA', label: 'Canadá', phone: '1' },
  { code: 'CH', label: 'Suiza', phone: '41' },
  { code: 'CL', label: 'Chile', phone: '56' },
  { code: 'CN', label: 'China', phone: '86' },
  { code: 'CO', label: 'Colombia', phone: '57' },
  { code: 'CR', label: 'Costa Rica', phone: '506' },
  { code: 'CU', label: 'Cuba', phone: '53' },
  { code: 'CV', label: 'Cabo Verde', phone: '238' },
  { code: 'CY', label: 'Chipre', phone: '357' },
  { code: 'CZ', label: 'República Checa', phone: '420' },
  { code: 'DE', label: 'Alemania', phone: '49' },
  { code: 'DK', label: 'Dinamarca', phone: '45' },
  { code: 'DO', label: 'República Dominicana', phone: '1-809' },
  { code: 'DZ', label: 'Argelia', phone: '213' },
  { code: 'EC', label: 'Ecuador', phone: '593' },
  { code: 'EE', label: 'Estonia', phone: '372' },
  { code: 'EG', label: 'Egipto', phone: '20' },
  { code: 'ES', label: 'España', phone: '34' },
  { code: 'FI', label: 'Finlandia', phone: '358' },
  { code: 'FR', label: 'Francia', phone: '33' },
  { code: 'GB', label: 'Reino Unido', phone: '44' },
  { code: 'GR', label: 'Grecia', phone: '30' },
  { code: 'GT', label: 'Guatemala', phone: '502' },
  { code: 'HK', label: 'Hong Kong', phone: '852' },
  { code: 'HN', label: 'Honduras', phone: '504' },
  { code: 'HR', label: 'Croacia', phone: '385' },
  { code: 'HU', label: 'Hungría', phone: '36' },
  { code: 'ID', label: 'Indonesia', phone: '62' },
  { code: 'IE', label: 'Irlanda', phone: '353' },
  { code: 'IL', label: 'Israel', phone: '972' },
  { code: 'IN', label: 'India', phone: '91' },
  { code: 'IT', label: 'Italia', phone: '39' },
  { code: 'JP', label: 'Japón', phone: '81' },
  { code: 'KR', label: 'Corea del Sur', phone: '82' },
  { code: 'MX', label: 'México', phone: '52' },
  { code: 'MY', label: 'Malasia', phone: '60' },
  { code: 'NL', label: 'Países Bajos', phone: '31' },
  { code: 'NO', label: 'Noruega', phone: '47' },
  { code: 'NZ', label: 'Nueva Zelanda', phone: '64' },
  { code: 'PA', label: 'Panamá', phone: '507' },
  { code: 'PE', label: 'Perú', phone: '51' },
  { code: 'PH', label: 'Filipinas', phone: '63' },
  { code: 'PL', label: 'Polonia', phone: '48' },
  { code: 'PT', label: 'Portugal', phone: '351' },
  { code: 'PY', label: 'Paraguay', phone: '595' },
  { code: 'RU', label: 'Rusia', phone: '7' },
  { code: 'SE', label: 'Suecia', phone: '46' },
  { code: 'SG', label: 'Singapur', phone: '65' },
  { code: 'TH', label: 'Tailandia', phone: '66' },
  { code: 'TR', label: 'Turquía', phone: '90' },
  { code: 'TW', label: 'Taiwán', phone: '886' },
  { code: 'UA', label: 'Ucrania', phone: '380' },
  { code: 'US', label: 'Estados Unidos', phone: '1' },
  { code: 'UY', label: 'Uruguay', phone: '598' },
  { code: 'VE', label: 'Venezuela', phone: '58' },
  { code: 'ZA', label: 'Sudáfrica', phone: '27' },
]

// Sort countries alphabetically by label
countries.sort((a, b) => a.label.localeCompare(b.label))

// Put Spain first
const spainIndex = countries.findIndex((c) => c.code === 'ES')
if (spainIndex !== -1) {
  const spain = countries.splice(spainIndex, 1)[0]
  countries.unshift(spain)
}

/**
 * Gets a specific country by its code
 */
export function getCountryByCode(code) {
  return countries.find((country) => country.code === code)
}

/**
 * Gets the default country (Spain)
 */
export function getDefaultCountry() {
  return countries[0] // Spain should be first in the array
}
